import { combineSlices } from '@reduxjs/toolkit'
import { agentsSlice } from './slices/agents/agentsSlice'
import { userSlice } from './slices/user/userSlice'
import { importSlice } from './slices/import/importSlice'
import { campaignSlice } from './slices/campaign/campaignSlice'

export const rootReducer = combineSlices(agentsSlice, userSlice, importSlice, campaignSlice)
